import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b5118eaa"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["href"];
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-external-link-alt" }, null, -1 /* HOISTED */));
import { useCampaignEditorPath } from "src/campaign/edit/component-id-url-mapper";
import Tooltip from "src/shared/v-components/ui/Tooltip.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableImpactTreeNodeControls',
    props: {
        componentId: {}
    },
    setup(__props) {
        const props = __props;
        const campaignEditorPath = useCampaignEditorPath(props.componentId);
        return (_ctx, _cache) => {
            return (_unref(campaignEditorPath))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "icon-button",
                    target: "_blank",
                    href: _unref(campaignEditorPath)
                }, [
                    _createVNode(Tooltip, { message: 'Open in New Tab' }, {
                        default: _withCtx(() => [
                            _hoisted_2
                        ]),
                        _: 1 /* STABLE */
                    })
                ], 8 /* PROPS */, _hoisted_1))
                : _createCommentVNode("v-if", true);
        };
    }
});
